import _ from 'lodash'

export const roundTypeChoices = [
  { label: 'Founders', value: 'FOUNDERS' },
  { label: 'Family & Friends', value: '3FS' },
  { label: 'Pre-seed', value: 'PRE_SEED' },
  { label: 'Seed', value: 'SEED' },
  { label: 'Pre-series A', value: 'PRE_SERIES_A' },
  { label: 'Series A', value: 'SERIES_A' },
  { label: 'Pre-series B', value: 'PRE_SERIES_B' },
  { label: 'Series B', value: 'SERIES_B' },
  { label: 'Series C+', value: 'OTHER' },
]

// roundTypeChoicesFnc is used as a default prop value and Objects/Arrays
// must use a factory function to return the default value.
export const roundTypeChoicesFnc = () => roundTypeChoices
export const currentRoundTypeChoices = roundTypeChoices.filter(
  ({ value }) => value !== 'FOUNDERS' && value !== '3FS',
)

export const roundTypeChoiceByLabel = _.keyBy(roundTypeChoices, 'label')
export const roundTypeChoiceByValue = _.keyBy(roundTypeChoices, 'value')

// might be used as filter
export function roundTypeLabel(val) {
  const choice = roundTypeChoiceByValue[val]
  if (choice) {
    return choice.label
  }
}

export const roundSourceChoices = [
  { label: 'Family & Friends', value: '3FS' },
  { label: 'Business Angel', value: 'BUSINESS_ANGEL' },
  { label: 'Accelerator / Incubator', value: 'ACCELERATOR' },
  { label: 'VC Fund', value: 'VC' },
  { label: 'Corporate', value: 'CORPORATE' },
  { label: 'Public grant', value: 'PUBLIC_GRANT' },
  { label: 'Crowd', value: 'CROWD' },
]

// roundSourceChoicesFnc is used as a default prop value and Objects/Arrays
// must use a factory function to return the default value.
export const roundSourceChoicesFnc = () => roundSourceChoices
export const currentRoundSourceChoices = roundSourceChoices.filter(
  ({ value }) => value !== '3FS',
)
export const previousRoundsSourceChoices = [
  { label: 'Founders', value: 'FOUNDERS' },
  ...roundSourceChoices,
]

export const roundSourceChoiceByLabel = _.keyBy(roundSourceChoices, 'label')
export const roundSourceChoiceByValue = _.keyBy(roundSourceChoices, 'value')

// might be used as filter
export function roundSourceLabel(val) {
  const choice = roundSourceChoiceByValue[val]
  if (choice) {
    return choice.label
  }
}

export function roundSourceArrayLabels(vals) {
  if (!vals) {
    return ''
  }
  return vals
    .map((val) => roundSourceLabel(val))
    .filter((l) => l)
    .join(', ')
}

export const previousRoundSourceChoiceByLabel = _.keyBy(
  previousRoundsSourceChoices,
  'label',
)
export const previousRoundSourceChoiceByValue = _.keyBy(
  previousRoundsSourceChoices,
  'value',
)

// might be used as filter
export function previousRoundsSourceLabel(val) {
  const choice = previousRoundSourceChoiceByValue[val]
  if (choice) {
    return choice.label
  }
}

export function previousRoundsSourceArrayLabels(vals) {
  if (!vals) {
    return ''
  }
  return vals
    .map((val) => previousRoundsSourceLabel(val))
    .filter((l) => l)
    .join(', ')
}

export const roundSecurityChoices = [
  { label: 'Common shares', value: 'COMMON_SHARES' },
  { label: 'Preferred shares', value: 'PREFERRED_SHARES' },
  { label: 'Convertible debt', value: 'CONVERTIBLE_DEBT' },
  { label: 'Loan', value: 'LOAN' },
  { label: 'Other', value: 'OTHER' },
]

export const roundSecurityChoiceByLabel = _.keyBy(roundSecurityChoices, 'label')
export const roundSecurityChoiceByValue = _.keyBy(roundSecurityChoices, 'value')

export function roundSecurityLabel(val) {
  const choice = roundSecurityChoiceByValue[val]
  if (choice) {
    return choice.label
  }
}

export function roundSecurityArrayLabels(vals) {
  if (!vals) {
    return ''
  }
  return vals
    .map((val) => roundSecurityLabel(val))
    .filter((l) => l)
    .join(', ')
}
